module.exports = __webpack_public_path__ + "static/media/introduce_more4.49035000.png";